import { transformToValidFromAndValidTo } from '../../../common/utils';
import { ZodObject, ZodRawShape } from 'zod/v3';
import { AlgorithmValidFormDataSchema } from './AlgorithmValidFormDataSchema';

const transform = <T extends ZodRawShape>(schemaVariant: ZodObject<T>) =>
  transformToValidFromAndValidTo(schemaVariant).transform(
    ({ id, ...algorithm }) => {
      return {
        ...algorithm,
        id: id !== -1 ? id : null,
      };
    },
  );

export const AlgorithmMutationDtoSchema = transform(
  AlgorithmValidFormDataSchema,
);
